import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { GlobalService, IEventRegisterReq, IRegisterRequest } from './global.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})


export class ApiService {
    private readonly baseUrl = environment.apiBaseURL;
    private readonly ipUrl = environment.ipURL;
    private readonly zipLookupUrl = environment.zipLookupURL;

    public showLoader: boolean = false;
    private baseAPIurl = '';

    constructor(private http: HttpClient, private globalService: GlobalService) {}



    getIP(): Observable<any> {
        return this.http.get(this.ipUrl);
    }



    getLocationInfo(zipCode: string = ""): Observable<any> {
        return this.http.get(`${this.zipLookupUrl}${zipCode}`);
    }


    getJobInfo(jobCode: string, ipAddress: string): Observable<any> {

        this.showLoader = true;

        let params = new HttpParams()
            .set('id', jobCode)
            .set('ip', ipAddress);

        let endpoint = "https://rsvp.org/includes/rsvp/prod/validate-code.php";

        return this.http.get(endpoint, { params }).pipe(
            tap(() => {
                this.showLoader = false;
            }),
            catchError((error) => {
                this.showLoader = false;
                console.error('API Error:', error);
                throw error; // Handle errors gracefully
            })
        );

    }



    getAvailableEvents(jobCode: string): Observable<any> {

        this.showLoader = true;

        let params = new HttpParams()
            .set('id', jobCode);

        let endpoint = "https://rsvp.org/includes/rsvp/prod/get-available-events.php";

        return this.http.get(endpoint, { params }).pipe(
            tap(() => {
                this.showLoader = false;
            }),
            catchError((error) => {
                this.showLoader = false;
                console.error('API Error:', error);
                throw error; // Handle errors gracefully
            })
        );

    }

    getQuestions(jobCode: string): Observable<any> {

        this.showLoader = true;

        let params = new HttpParams()
            .set('id', jobCode);

        let endpoint = "https://rsvp.org/includes/rsvp/prod/get-questions.php";

        return this.http.get(endpoint, { params }).pipe(
            tap(() => {
                this.showLoader = false;
            }),
            catchError((error) => {
                this.showLoader = false;
                console.error('API Error:', error);
                throw error; // Handle errors gracefully
            })
        );

    }


  addRespondent(request: IRegisterRequest): Observable<any> {
    
    // const param = new HttpParams()
    // .set('campaignId', request.campaignId)
    // .set('code', request.code)
    // .set('firstName', request.firstName)
    // .set('lastName', request.lastName)
    // .set('addressLine1', request.addressLine1)
    // .set('addressLine2', request.addressLine2)
    // .set('city', request.city!)
    // .set('state', request.state!)
    // .set('zip', request.zip)
    // .set('phone', request.phone)
    // .set('email', request.email)
    // .set('phoneType', request.phoneType)
    // .set('audience_Key', request.audience_Key)

    let endpoint = `${this.baseUrl}/api/addRespondent`;
    return this.http.post(endpoint, request, 
        {
          headers: { 'X-Skip-Loader': 'true' }
        }
        )
  } 

  eventRegisteration(request: IEventRegisterReq): Observable<any> {
   
    let endpoint = `${this.baseUrl}/api/eventRegistration`;

    //return throwError(()=> new Error('test')) // failed case scenario
    
    return this.http.post(endpoint, request, 
        {
          headers: { 'X-Skip-Loader': 'true' }
        }
        )
  } 

  getJobData(code:number, ip:string): Observable<any>{
      const param = new HttpParams()
    .set('code', code)
    .set('ipAddress', ip)
    let endpoint = `${this.baseUrl}/api/reservationServiceInfo`;
    return this.http.get(endpoint, {params:param})
  }

  getPageData(job:number): Observable<any>{
    const param = new HttpParams()
  .set('jobNumber', job)
  let endpoint = `${this.baseUrl}/api/jobDetails`;
  return this.http.get(endpoint, {params:param})
}

}


export interface ZipInfo {
    cityId:string;
    cityName:string;
    stateId:string;
    zipCode:string;
  }
  